module.exports = __webpack_public_path__ + "static/media/logo-rambody.6f2da0b2.png";